<template>
  <!-- Footer Start -->
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 text-center">
          {{ CurrentYear }} ©
          <a
            href="https://jciindia.in"
            target="_blank"
            class="text-dark-75 text-hover-primary"
            >JCI India</a
          >
          - Powered by
          <a
            href="http://vaagai.org.in"
            target="_blank"
            class="text-dark-75 text-hover-primary"
            >Vaagai Tecknowledge</a
          >
        </div>
      </div>
    </div>
  </footer>
  <!-- end Footer -->
</template>

<script>
export default {
  data() {
    return {
      CurrentYear: new Date().getFullYear(),
    };
  },
};
</script>

